export default __webpack_public_path__ + "static/media/kid21.9d8dec27.jpg";